import InfoTooltip from '@/components/Tooltip/InfoTooltip';
import { memo } from 'react';

const ScheduleReportTooltip = memo(() => (
  <InfoTooltip
    title={
      <div>
        <p>In order to be able to schedule a report you need:</p>
        <ul className='list-disc px-3'>
          <li>At least one metric or dimension</li>
          <li>
            Selected time range to not be <strong>Custom</strong>
          </li>
        </ul>
      </div>
    }
    className='relative'
  />
));

export default ScheduleReportTooltip;
